import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
import { crown, isLiveOnBoard, maturation, photosynthesis, tableOf } from './plant-helpers.js';
/**
 * Побег баньяна: при раскрытии создаёт Лист, затем растёт через Фотосинтез и
 * Крону; Созревание 4 превращает его в Великого баньяна 8/10.
 */
export const BanyanShootCard = defineGameCard({
    id: 'banyan_shoot',
    gameplay: {
        type: 'UNIT',
        cost: 4,
        baseStats: { attack: 0, health: 5 },
        traits: ['PLANT', 'TREE'],
        keywords: ['CANNOT_ATTACK'],
    },
    presentation: {
        name: 'Побег баньяна',
        description: 'При раскрытии создайте Лист в этой локации, если есть место. Не атакует. Фотосинтез. Крона. Созревание 4: превращается в Великий баньян 8/10.',
        glyph: {
            colors: ['#10213A', '#669741', '#87B74C', '#527837', '#618F3E'],
            rows: [
                '....................',
                '.11111........11111.',
                '1222221......1222221',
                '12233321....12333321',
                '.12233331..13334221.',
                '..1224335112332221..',
                '..1555235115344551..',
                '..1445543445455441..',
                '...14444444452241...',
                '....111114411111....',
                '.........141........',
                '.........131........',
                '.........131........',
                '.........131........',
                '.........131........',
                '.........131........',
                '.........131........',
                '........1441........',
                '........1441........',
                '.........11.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onAppear({
            source: 'card_effect',
            dependencies: [cardRef('plant_leaf')],
            run: (ctx) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self))
                    return;
                ctx.ops.createTokenInLocation('plant_leaf', self.controllerId, tableOf(self.cellId));
            },
        }, { cause: 'played' }),
        ...photosynthesis(),
        ...crown(),
        maturation('banyan_shoot', 4, { id: 'great_banyan', attack: 8, health: 10 }),
    ],
    ui: {
        mechanics: ['cannot_attack', 'growth', 'photosynthesis', 'crown', 'maturation', 'token'],
    },
});
//# sourceMappingURL=banyan_shoot.js.map